<template>
  <div class="modal fade" id="alert_modal" tabindex="-1" role="dialog" data-backdrop="false">
    <div class="modal-dialog">
      <div class="modal-content" v-if="alert.message">
        <div class="grid-elm grid-align-1-1 grid-offset text-center" :class="`alert ${alert.type}`">                                                                                             
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <div class="alert-message">
            {{alert.message}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default{
  name: 'AlertMessageModal',
  computed: {
    ...mapState({
      alert: state => state.alert
    })
  },
  methods: {
    ...mapActions({
      clearAlert: 'alert/clear'
    })
  }
};
</script>

<style>
.alert-message {
  border-radius: .3rem;
  box-shadow: none;
}
.slide-fade-enter-active {
  transition: all .8s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
#alert_modal .alert{
  border-radius: .3rem;
}
</style>



// WEBPACK FOOTER //
// source/components/AlertMessageModal.vue